import { render, staticRenderFns } from "./ExamProfilesNew.vue?vue&type=template&id=4c738be8"
import script from "./ExamProfilesNew.vue?vue&type=script&lang=js"
export * from "./ExamProfilesNew.vue?vue&type=script&lang=js"
import style0 from "./ExamProfilesNew.vue?vue&type=style&index=0&id=4c738be8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports